import { SwitchFieldUI } from '@axo/form/feature/form-input/SwitchField/SwitchFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useFormContext } from 'react-hook-form';
import { CoApplicantFormGroupData } from '../../FormData.se.types';
import { CoAppFormGroup } from './CoAppFormGroup';

export const CoApplicant = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const addCoApplicant = watch('Frontend/AddCoApplicant');

  return (
    <>
      <SwitchFieldUI<CoApplicantFormGroupData>
        name="Frontend/AddCoApplicant"
        description={t('AddCoApplicant.label')}
        data-testid="add-co-applicant-switch"
      />

      {addCoApplicant && <CoAppFormGroup />}
    </>
  );
};
